import { Print } from '@mui/icons-material'
import { Button, Card, CardContent, Grid } from '@mui/material'
import { ExplanationAccordion } from 'components'
import { useLayout } from 'context'
import { VehicleDto } from 'dtos'
import * as controllers from 'controllers'
import { useEffect } from 'react'

interface LabelDetailsCardProps {
  vehicle: VehicleDto
  id?: string
}

export default function LabelDetailsCard({ vehicle, id }: LabelDetailsCardProps) {
  const layout = useLayout()

  useEffect(() => {
    controllers.initializeBluetoothLabelPrinterState().catch(error => {
      console.warn('Could not initialize Bluetooth label printer state:', error)
    })
  }, [])

  return (
    <>
      <Card>
        <CardContent>
          <Grid container spacing={2} alignItems='center' justifyContent='center'>
            <Grid item xs={12}>
              <Button
                color='primary'
                endIcon={<Print />}
                fullWidth
                onClick={() => {
                  layout.setIsLayoutLoading(true)
                  controllers
                    .printBluetoothLabelFromUserGesture({
                      getPrn: () => controllers.getImporterDoorLabel(id!),
                      labelPrintContextTypeId: controllers.LABEL_PRINT_CONTEXT_TYPE_VEHICLE_DETAILS_ID,
                      labelTypeId: controllers.LABEL_TYPE_IMPORTER_DOOR_ID,
                      vehicleGuid: id
                    })
                    .finally(() => {
                      layout.setIsLayoutLoading(false)
                    })
                }}
                variant='outlined'
              >
                PRINT IMPORTER DOOR LABEL
              </Button>
            </Grid>

            <Grid item xs={12}>
              <Button
                color='primary'
                endIcon={<Print />}
                fullWidth
                onClick={() => {
                  layout.setIsLayoutLoading(true)
                  controllers
                    .printBluetoothLabelFromUserGesture({
                      getPrn: () => controllers.getClusterConversionLabel(id!),
                      labelPrintContextTypeId: controllers.LABEL_PRINT_CONTEXT_TYPE_VEHICLE_DETAILS_ID,
                      labelTypeId: controllers.LABEL_TYPE_CLUSTER_CONVERT_ID,
                      vehicleGuid: id
                    })
                    .finally(() => {
                      layout.setIsLayoutLoading(false)
                    })
                }}
                variant='outlined'
              >
                PRINT CLUSTER CONVERT LABEL
              </Button>
            </Grid>

            <Grid item xs={12}>
              <Button
                color='primary'
                endIcon={<Print />}
                fullWidth
                onClick={() => {
                  layout.setIsLayoutLoading(true)
                  controllers
                    .printBluetoothLabelFromUserGesture({
                      getPrn: () => controllers.getClusterProgrammingLabel(id!),
                      labelPrintContextTypeId: controllers.LABEL_PRINT_CONTEXT_TYPE_VEHICLE_DETAILS_ID,
                      labelTypeId: controllers.LABEL_TYPE_CLUSTER_PROGRAMMING_ID,
                      vehicleGuid: id
                    })
                    .finally(() => {
                      layout.setIsLayoutLoading(false)
                    })
                }}
                variant='outlined'
              >
                PRINT CLUSTER PROGRAMMING LABEL
              </Button>
            </Grid>

            <Grid item xs={12}>
              <Button
                color='primary'
                endIcon={<Print />}
                fullWidth
                onClick={() => {
                  layout.setIsLayoutLoading(true)
                  controllers
                    .printBluetoothLabelFromUserGesture({
                      getPrn: () => controllers.getWindowLabel(id!),
                      labelPrintContextTypeId: controllers.LABEL_PRINT_CONTEXT_TYPE_VEHICLE_DETAILS_ID,
                      labelTypeId: controllers.LABEL_TYPE_WINDOW_ID,
                      vehicleGuid: id
                    })
                    .finally(() => {
                      layout.setIsLayoutLoading(false)
                    })
                }}
                variant='outlined'
              >
                PRINT WINDOW LABEL
              </Button>
            </Grid>

            <Grid item xs={12}>
              <Button
                color='primary'
                endIcon={<Print />}
                fullWidth
                onClick={() => {
                  layout.setIsLayoutLoading(true)
                  controllers
                    .printBluetoothLabelFromUserGesture({
                      getPrn: () => controllers.getKeyTagLabel(id!),
                      labelPrintContextTypeId: controllers.LABEL_PRINT_CONTEXT_TYPE_VEHICLE_DETAILS_ID,
                      labelTypeId: controllers.LABEL_TYPE_KEY_TAG_ID,
                      vehicleGuid: id
                    })
                    .finally(() => {
                      layout.setIsLayoutLoading(false)
                    })
                }}
                variant='outlined'
              >
                PRINT KEY TAG LABEL
              </Button>
            </Grid>

            <Grid item xs={12}>
              <ExplanationAccordion variant='outlined'>
                || To print from a webpage open in Chrome on your phone to your Zebra ZQ520 label printer connected via
                Bluetooth, follow these steps: || - Ensure Bluetooth Connectivity: Make sure that your Zebra ZQ520 label printer
                is powered on and paired with your phone via Bluetooth. Check your phone's Bluetooth settings to confirm the
                connection. || - Select the desired label in VTS2: Navigate to the label you want to print from using the Chrome
                browser on your phone and press the PRINT button in the UI || - Access the Print Function: Tap on the three dots
                located at the top-right corner of the Chrome browser window to open the browser menu. || - Select "Print": From
                the browser menu, select the "Print" option. This will open the print settings for the webpage. || - Choose
                Printer: In the print settings, locate and select the option to choose a printer. Your Zebra ZQ520 label printer
                should appear in the list of available printers. Select it as the printing device. || - Adjust Print Settings
                (Optional): Depending on your preferences and the content of the webpage, you may want to adjust print settings
                such as page layout, paper size, and orientation. || - Preview and Print: Once you have configured the print
                settings, you can preview how the webpage will look when printed. Ensure everything appears as desired. || -
                Initiate Printing: After confirming the print preview, tap on the "Print" button to send the print job to your
                Zebra ZQ520 label printer via Bluetooth. || - Wait for Printing to Complete: Allow the printer to process the
                print job. Depending on the printer's speed, this may take a few moments. ||
              </ExplanationAccordion>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
